//SAVE_USER_LATE_TIME
export const SAVE_USER_LATE_TIME_REQUEST = "SAVE_USER_LATE_TIME_REQUEST";
export const SAVE_USER_LATE_TIME_SUCCESS = "SAVE_USER_LATE_TIME_SUCCESS";
export const SAVE_USER_LATE_TIME_FAIL = "SAVE_USER_LATE_TIME_FAIL";

//GET_ALL_LATE_TIME
export const GET_ALL_LATE_TIME_REQUEST = "GET_ALL_LATE_TIME_REQUEST";
export const GET_ALL_LATE_TIME_SUCCESS = "GET_ALL_LATE_TIME_SUCCESS";
export const GET_ALL_LATE_TIME_FAIL = "GET_ALL_LATE_TIME_FAIL";

//SHIFT_TO_CHECKIN
export const SHIFT_TO_CHECKIN_REQUEST = "SHIFT_TO_CHECKIN_REQUEST";
export const SHIFT_TO_CHECKIN_SUCCESS = "SHIFT_TO_CHECKIN_SUCCESS";
export const SHIFT_TO_CHECKIN_FAIL = "SHIFT_TO_CHECKIN_FAIL";

//OVERTIME_SETTINGS_ENABLE
export const OVERTIME_SETTINGS_ENABLE_REQUEST =
  "OVERTIME_SETTINGS_ENABLE_REQUEST";
export const OVERTIME_SETTINGS_ENABLE_SUCCESS =
  "OVERTIME_SETTINGS_ENABLE_SUCCESS";
export const OVERTIME_SETTINGS_ENABLE_FAIL = "OVERTIME_SETTINGS_ENABLE_FAIL";

//GET_OVERTIME_SETTINGS
export const GET_OVERTIME_SETTINGS_REQUEST = "GET_OVERTIME_SETTINGS_REQUEST";
export const GET_OVERTIME_SETTINGS_SUCCESS = "GET_OVERTIME_SETTINGS_SUCCESS";
export const GET_OVERTIME_SETTINGS_FAIL = "GET_OVERTIME_SETTINGS_FAIL";
